export default "__VITE_ASSET__BSYkpnY8__"